export const STORAGE_KEY = 'gu.logger';
